(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chesto-thuisbioscoop-pdp"] && !Shopify.designMode) return;
  try {
    

(function(){
  var ICONS = {
    sparkles:'<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>',
    star:'<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    plug:'<path d="M12 22v-5"/><path d="M9 8V2"/><path d="M15 8V2"/><path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"/>',
    maximize:'<path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/>',
    shield:'<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    clock:'<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
    rotateCcw:'<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
    headphones:'<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H4a1 1 0 0 1-1-1v-6a9 9 0 0 1 18 0v6a1 1 0 0 1-1 1h-2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>',
    truck:'<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    heart:'<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/>',
    check:'<path d="M20 6 9 17l-5-5"/>',
    plus:'<line x1="12" x2="12" y1="5" y2="19"/><line x1="5" x2="19" y1="12" y2="12"/>',
    chevronDown:'<path d="m6 9 6 6 6-6"/>',
    monitor:'<rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/>',
    anchor:'<path d="M12 22V8"/><path d="M5 12H2a10 10 0 0 0 20 0h-3"/><circle cx="12" cy="5" r="3"/>',
    package:'<path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
    projector:'<path d="M5 7 3 5"/><path d="M9 6V3"/><path d="m13 7 2-2"/><circle cx="9" cy="13" r="3"/><path d="M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17"/><path d="M16 16h.01"/>',
    searchX:'<path d="m13.5 8.5-5 5"/><path d="m8.5 8.5 5 5"/><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
    wallet:'<path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/>'
  };
  function svg(name, size){ if(!ICONS[name]) return ''; return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="'+(name==='star'?'currentColor':'none')+'" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">'+ICONS[name]+'</svg>'; }
  function sizeFor(el){
    if(el.closest('.tb-best-badge')) return 13;
    if(el.closest('.tb-feature__icon')) return 19;
    if(el.closest('.tb-hero__trust-item')) return 17;
    if(el.closest('.tb-thumb')) return 20;
    if(el.closest('.is-check')||el.closest('.tb-specs')||el.closest('.tb-hero__media')) return 17;
    if(el.closest('.tb-faq__toggle')) return 20;
    if(el.closest('.tb-trust__icon')||el.closest('.tb-wish')) return 19;
    if(el.closest('.tb-delivery')) return 16;
    if(el.closest('.tb-why__icon')) return 17;
    if(el.closest('.tb-compare__eyebrow')||el.closest('.tb-why__eyebrow')||el.closest('.tb-get__eyebrow')) return 13;
    if(el.closest('.tb-get__placeholder')) return 56;
    if(el.closest('.tb-why__item')) return 20;
    return 20;
  }
  function init(root){
    root.querySelectorAll('.ic[data-i]').forEach(function(el){ el.innerHTML = svg(el.getAttribute('data-i'), sizeFor(el)); });
    root.querySelectorAll('[data-stars]').forEach(function(el){ var n=parseInt(el.getAttribute('data-stars'),10)||5; var h=''; for(var i=0;i<n;i++)h+=svg('star',14); el.innerHTML=h; });

    var form = root.querySelector('[data-tb-form]');
    var variantInput = root.querySelector('[data-tb-variant]');
    var stickyPrice = root.querySelector('[data-tb-sticky-price]');
    var stickyCompare = root.querySelector('[data-tb-sticky-compare]');
    var savingsBars = root.querySelectorAll('[data-tb-savings]');
    function select(opt){
      root.querySelectorAll('[data-tb-option]').forEach(function(o){ o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      if(variantInput) variantInput.value = opt.getAttribute('data-variant') || '';
      if(stickyPrice) stickyPrice.textContent = opt.getAttribute('data-price') || '';
      if(stickyCompare){
        var cp = opt.getAttribute('data-compare-price') || '';
        stickyCompare.textContent = cp;
        stickyCompare.style.display = cp ? '' : 'none';
      }
      /* Bespaar-pil per variant — toon "Bespaar €X t.o.v. los kopen" of verberg als geen besparing */
      var savings = opt.getAttribute('data-savings') || '';
      savingsBars.forEach(function(bar){
        var amt = bar.querySelector('[data-tb-savings-amount]');
        if(amt) amt.textContent = savings;
        bar.style.display = savings ? '' : 'none';
      });
    }
    var opts = root.querySelectorAll('[data-tb-option]');
    opts.forEach(function(opt){ opt.addEventListener('click', function(){ select(opt); }); });
    var sel = root.querySelector('[data-tb-option].is-selected') || opts[0];
    if(sel) select(sel);

    root.querySelectorAll('[data-tb-faq] .tb-faq__q').forEach(function(q){ q.addEventListener('click', function(){ q.closest('[data-tb-faq]').classList.toggle('is-open'); }); });
    var firstFaq = root.querySelector('[data-tb-faq]'); if(firstFaq) firstFaq.classList.add('is-open');

    var stickyAdd = root.querySelector('[data-tb-sticky-add]');
    if(stickyAdd && form){ stickyAdd.addEventListener('click', function(){ if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); } }); }
  }
  function boot(){ document.querySelectorAll('[data-tb-root]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about-us"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root) return;
    
      // -------- reveal on scroll --------
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            if (e.target.classList.contains('reveal')) io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    
      root.querySelectorAll('.reveal').forEach(el => io.observe(el));
    
      // hero — reveal immediately
      requestAnimationFrame(() => {
        root.querySelector('#hero').classList.add('revealed');
      });
    
      // -------- count-up stats --------
      const formatCount = (target, value, suffix) => {
        if (Number.isInteger(target)) {
          return Math.round(value).toLocaleString('nl-NL') + suffix;
        }
        return value.toFixed(1).replace('.', ',') + suffix;
      };
    
      const countObs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          const el = e.target;
          const target = parseFloat(el.dataset.count);
          const suffix = el.dataset.suffix || '';
          const dur = 1600;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - start) / dur);
            // ease-out cubic
            const eased = 1 - Math.pow(1 - p, 3);
            const val = target * eased;
            el.innerHTML = formatCount(target, val, '') + '<span class="suffix">' + suffix + '</span>';
            if (p < 1) requestAnimationFrame(tick);
            else el.innerHTML = formatCount(target, target, '') + '<span class="suffix">' + suffix + '</span>';
          };
          requestAnimationFrame(tick);
          countObs.unobserve(el);
        });
      }, { threshold: 0.4 });
      root.querySelectorAll('[data-count]').forEach(el => countObs.observe(el));
    
      // -------- timeline (scroll-driven, desktop + mobile) --------
      const yearBtns = [...root.querySelectorAll('.year-btn')];
      const cards = [...root.querySelectorAll('.event-card')];
      const railFill = root.querySelector('#yearRailFill');
      const timelineTrack = root.querySelector('#timelineTrack');
      const timelineHint = root.querySelector('#timelineHint');
      const yearsCount = yearBtns.length; // 7
      let activeIdx = -1;
      let hintHidden = false;
    
      function setYear(i) {
        if (i === activeIdx) return;
        activeIdx = i;
        yearBtns.forEach((b, n) => b.classList.toggle('active', n === i));
        cards.forEach((c, n) => c.classList.toggle('active', n === i));
      }
    
      // Map scroll position within the track to a continuous 0..1 progress,
      // then to a discrete year index.
      function updateTimeline() {
        const rect = timelineTrack.getBoundingClientRect();
        const scrollable = timelineTrack.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const scrolled = Math.max(0, Math.min(scrollable, -rect.top));
        const progress = scrolled / scrollable;
        railFill.style.width = (progress * 100) + '%';
        const idx = Math.min(yearsCount - 1, Math.floor(progress * yearsCount * 0.9999));
        setYear(idx);
        if (!hintHidden && progress > 0.04) {
          timelineHint.classList.add('hidden');
          hintHidden = true;
        }
      }
    
      // Quick-jump: clicking a year chip scrolls to that year's slot
      yearBtns.forEach((b, i) => b.addEventListener('click', () => {
        const trackRect = timelineTrack.getBoundingClientRect();
        const scrollable = timelineTrack.offsetHeight - window.innerHeight;
        const targetProgress = (i + 0.5) / yearsCount;
        const trackTop = window.scrollY + trackRect.top;
        window.scrollTo({ top: trackTop + scrollable * targetProgress, behavior: 'smooth' });
      }));
    
      let scrollTicking = false;
      window.addEventListener('scroll', () => {
        if (scrollTicking) return;
        requestAnimationFrame(() => { updateTimeline(); scrollTicking = false; });
        scrollTicking = true;
      }, { passive: true });
      window.addEventListener('resize', updateTimeline, { passive: true });
      updateTimeline();
    
      // -------- subtle parallax on hero halo --------
      const halo = root.querySelector('.hero-halo');
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        requestAnimationFrame(() => {
          const y = window.scrollY;
          if (halo && y < 1200) {
            halo.style.transform = `translate3d(${y * 0.05}px, ${y * 0.2}px, 0)`;
          }
          ticking = false;
        });
        ticking = true;
      }, { passive: true });
    
  }

  // Find all .chesto-about sections on this page and initialise once each
  function boot() {
    document.querySelectorAll('.chesto-about').forEach(function (el) {
      if (el.dataset.chestoInited) return;
      el.dataset.chestoInited = '1';
      init(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor: re-init on section reload
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.chesto-about') || (e.target.classList && e.target.classList.contains('chesto-about') ? e.target : null);
    if (el) {
      el.dataset.chestoInited = '1';
      init(el);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pt-card').forEach(function (card) {
      var tabs = card.querySelectorAll('[data-pt-target]');
      var panes = card.querySelectorAll('[data-pt-pane]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-pt-target');
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panes.forEach(function (p) {
            p.hidden = p.getAttribute('data-pt-pane') !== target;
          });
        });
      });

      card.querySelectorAll('[data-pt-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pane = btn.closest('[data-pt-pane]');
          if (!pane) return;
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var next = !expanded;
          btn.setAttribute('aria-expanded', next ? 'true' : 'false');
          pane.querySelectorAll('[data-pt-extra]').forEach(function (el) {
            el.hidden = !next;
          });
          var label = btn.querySelector('[data-pt-more-label]');
          if (label) {
            label.textContent = next
              ? btn.dataset.lessLabel || label.dataset.less || label.textContent
              : btn.dataset.moreLabel || label.dataset.more || label.textContent;
          }
        });
      });

      // Stash both labels on the toggle button on init so we can swap
      card.querySelectorAll('[data-pt-toggle]').forEach(function (btn) {
        var label = btn.querySelector('[data-pt-more-label]');
        if (!label) return;
        if (!btn.dataset.moreLabel) btn.dataset.moreLabel = label.textContent;
        if (!btn.dataset.lessLabel) btn.dataset.lessLabel = btn.dataset.lessLabel || label.dataset.less || label.textContent;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pv-video]').forEach(function (wrap) {
      var nativeVid = wrap.querySelector('[data-pv-native]');

      /* === Native uploaded video — autoplay muted in viewport, click to unmute === */
      if (nativeVid) {
        var muteBtn = wrap.querySelector('[data-pv-mute]');
        var iconOn = wrap.querySelector('.pv-mute-on');
        var iconOff = wrap.querySelector('.pv-mute-off');

        /* Try to start playback as soon as it can. Browsers allow muted autoplay. */
        var tryPlay = function () {
          var p = nativeVid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        };
        if (nativeVid.readyState >= 2) tryPlay();
        nativeVid.addEventListener('loadeddata', tryPlay, { once: true });

        /* Pause when fully out of view, resume when visible — save bandwidth */
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) tryPlay();
              else nativeVid.pause();
            });
          }, { threshold: 0.25 });
          io.observe(nativeVid);
        }

        /* Mute toggle */
        if (muteBtn) {
          muteBtn.addEventListener('click', function (ev) {
            ev.stopPropagation();
            nativeVid.muted = !nativeVid.muted;
            muteBtn.setAttribute('aria-pressed', String(!nativeVid.muted));
            if (iconOn) iconOn.hidden = !nativeVid.muted;
            if (iconOff) iconOff.hidden = nativeVid.muted;
            if (nativeVid.paused) tryPlay();
          });
        }
        return;
      }

      /* === External URL flow (YouTube/Vimeo/MP4 link) — click to play === */
      var btn = wrap.querySelector('.pv-play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = wrap.getAttribute('data-pv-src');
        if (!src) return;
        var isYouTube = /youtu(\.be|be\.com)/.test(src);
        var isVimeo = /vimeo\.com/.test(src);
        var embed;
        if (isYouTube) {
          var id = src.match(/(?:v=|youtu\.be\/)([^&?#]+)/);
          embed = '<iframe src="https://www.youtube.com/embed/' + (id ? id[1] : '') + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen frameborder="0" style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe>';
        } else if (isVimeo) {
          var vid = src.match(/vimeo\.com\/(\d+)/);
          embed = '<iframe src="https://player.vimeo.com/video/' + (vid ? vid[1] : '') + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen frameborder="0" style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe>';
        } else {
          embed = '<video src="' + src + '" controls autoplay style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000"></video>';
        }
        wrap.innerHTML = embed;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
